export default __webpack_public_path__ + "media/images/comment-5b3b283c1c70459aa186baa65b1e1668.svg";